/**
 * Login Typewriter
 *
 * Runs a looping typewriter animation on the static chat input inside the
 * login overlay's decorative pane. Mirrors the landing page's hero-chat
 * effect (shared message list, shared pacing).
 */

const MESSAGES = [
  "How do we strengthen our marriage?",
  "How do we communicate better?",
  "How do we deepen our connection?",
  "I want to understand myself.",
  "I want to understand my partner.",
  "Why do we keep fighting about sex?",
  "Why do we keep fighting about money?",
];

const TYPE_MIN = 28;
const TYPE_MAX = 70;
const DELETE_SPEED = 18;
const PAUSE_AFTER_TYPE = 1800;
const PAUSE_BEFORE_NEXT = 400;
const MIN_SHARED_PREFIX = 4;

let timerId = null;
let running = false;

const rand = (min, max) => min + Math.random() * (max - min);

function commonPrefixLen(a, b) {
  const max = Math.min(a.length, b.length);
  let i = 0;
  while (i < max && a[i] === b[i]) i++;
  return i;
}

export function startLoginTypewriter() {
  const field = document.getElementById('login-typewriter-field');
  if (!field || running) return;
  running = true;

  let msgIdx = 0;
  let charIdx = 0;
  let phase = 'typing';
  let deleteTarget = 0;

  function tick() {
    if (!running) return;
    const current = MESSAGES[msgIdx];

    if (phase === 'typing') {
      charIdx++;
      field.value = current.slice(0, charIdx);
      if (charIdx >= current.length) {
        phase = 'pausing';
        timerId = setTimeout(tick, PAUSE_AFTER_TYPE);
        return;
      }
      timerId = setTimeout(tick, rand(TYPE_MIN, TYPE_MAX));
    } else if (phase === 'pausing') {
      const nextIdx = (msgIdx + 1) % MESSAGES.length;
      const shared = commonPrefixLen(current, MESSAGES[nextIdx]);
      deleteTarget = shared >= MIN_SHARED_PREFIX ? shared : 0;
      phase = 'deleting';
      timerId = setTimeout(tick, DELETE_SPEED);
    } else if (phase === 'deleting') {
      if (charIdx <= deleteTarget) {
        msgIdx = (msgIdx + 1) % MESSAGES.length;
        phase = 'typing';
        timerId = setTimeout(tick, PAUSE_BEFORE_NEXT);
        return;
      }
      charIdx--;
      field.value = current.slice(0, charIdx);
      timerId = setTimeout(tick, DELETE_SPEED);
    }
  }

  tick();
}

export function stopLoginTypewriter() {
  running = false;
  if (timerId) {
    clearTimeout(timerId);
    timerId = null;
  }
  const field = document.getElementById('login-typewriter-field');
  if (field) field.value = '';
}
